// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ConnectionStatusMessage, ConnectionStatusMessageT } from './connection-status-message';
import { DoorStatusMessage, DoorStatusMessageT } from './door-status-message';
import { EarthquakeProtectionMessage, EarthquakeProtectionMessageT } from './earthquake-protection-message';
import { EarthquakeStatusMessage, EarthquakeStatusMessageT } from './earthquake-status-message';
import { ElevatorStatusContent, unionToElevatorStatusContent, unionListToElevatorStatusContent } from './elevator-status-content';
import { GeneralStatusMessage, GeneralStatusMessageT } from './general-status-message';
import { LoadWeigherStatusMessage, LoadWeigherStatusMessageT } from './load-weigher-status-message';
import { ModeStatusMessage, ModeStatusMessageT } from './mode-status-message';
import { TrafficStatusMessage, TrafficStatusMessageT } from './traffic-status-message';


export class ElevatorStatusMessage implements flatbuffers.IUnpackableObject<ElevatorStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorStatusMessage):ElevatorStatusMessage {
  return (obj || new ElevatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorStatusMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorStatusMessage):ElevatorStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

statusType():ElevatorStatusContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : ElevatorStatusContent.NONE;
}

status<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startElevatorStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addStatusType(builder:flatbuffers.Builder, statusType:ElevatorStatusContent) {
  builder.addFieldInt8(0, statusType, ElevatorStatusContent.NONE);
}

static addStatus(builder:flatbuffers.Builder, statusOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, statusOffset, 0);
}

static endElevatorStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // status
  return offset;
}

static createElevatorStatusMessage(builder:flatbuffers.Builder, statusType:ElevatorStatusContent, statusOffset:flatbuffers.Offset):flatbuffers.Offset {
  ElevatorStatusMessage.startElevatorStatusMessage(builder);
  ElevatorStatusMessage.addStatusType(builder, statusType);
  ElevatorStatusMessage.addStatus(builder, statusOffset);
  return ElevatorStatusMessage.endElevatorStatusMessage(builder);
}

unpack(): ElevatorStatusMessageT {
  return new ElevatorStatusMessageT(
    this.statusType(),
    (() => {
      const temp = unionToElevatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: ElevatorStatusMessageT): void {
  _o.statusType = this.statusType();
  _o.status = (() => {
      const temp = unionToElevatorStatusContent(this.statusType(), this.status.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class ElevatorStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public statusType: ElevatorStatusContent = ElevatorStatusContent.NONE,
  public status: ConnectionStatusMessageT|DoorStatusMessageT|EarthquakeProtectionMessageT|EarthquakeStatusMessageT|GeneralStatusMessageT|LoadWeigherStatusMessageT|ModeStatusMessageT|TrafficStatusMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const status = builder.createObjectOffset(this.status);

  return ElevatorStatusMessage.createElevatorStatusMessage(builder,
    this.statusType,
    status
  );
}
}
